import React, {Component} from "react";
import FileRecordClass from "./FileRecordClass";

class DataRecordcard extends Component{

    state = {
        input : [],
        printReportCard : false
    }

    render(){
        
        var  max=0, note=0, note_ = 0, max_ = 0;
        var list = 
        this.props.section.sectionclasses?.sort((a, b) => a.class?.short_entitled_class > b.class?.short_entitled_class ? -1 : 1).map((sectionclasse) => {
            max=0;
            note=0
            return(
                <FileRecordClass section={ { id : this.props.section?.id, short_entitled_section : this.props.section?.short_entitled_section, entitled_section : this.props.section?.entitled_section }} sectionclasse={ sectionclasse} />
            )
        })

        return( list )
    }
}
export default DataRecordcard